<template>
  <div class="page-password" page_id="page_reset_password">
    <el-dialog width="25%"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogFormVisible">
      <h2>{{$t('setting.setPassword.title')}}</h2>
      <el-form :model="form"
               :rules="rules"
               ref="form"
               class="form-password"
               :label-position="labelPosition">
        <el-form-item :label="$t('setting.setPassword.oldPassword')"
                      prop="oldPassword"
                      :label-width="formLabelWidth">
          <el-input v-model="form.oldPassword"
                    :type="isShowOldPwd ?'text':'password'"
                    maxlength="16"
                    autocomplete="off"
                    test_id= "input_setting_oldpassword"></el-input>
          <img :src=" isShowOldPwd ? require('@/assets/images/disabledPwd.svg'):require('@/assets/images/showPwd.svg')"
               alt=""
               class="showPwdIcon"
               @click="isShowOldPwd=!isShowOldPwd"
               test_id= "setting_isShowOldPwd">
        </el-form-item>
        <el-form-item :label="$t('setting.setPassword.newPassword')"
                      prop="newPassword"
                      :label-width="formLabelWidth">
          <el-input v-model="form.newPassword"
                    maxlength="16"
                    :type="isShowNewPwd ?'text':'password'"
                    autocomplete="off"
                    test_id= "input_setting_newpassword"></el-input>
          <img :src=" isShowNewPwd ? require('@/assets/images/disabledPwd.svg'):require('@/assets/images/showPwd.svg')"
               alt=""
               class="showPwdIcon"
               @click="isShowNewPwd=!isShowNewPwd"
               test_id= "setting_isShowNewPwd">
        </el-form-item>
        <el-form-item :label="$t('setting.setPassword.confirmPassword')"
                      prop="confirmPassword"
                      :label-width="formLabelWidth">
          <el-input v-model="form.confirmPassword"
                    maxlength="16"
                    :type="isShowConfirmPwd ?'text':'password'"
                    autocomplete="off"
                    test_id= "input_setting_confirmpassword"></el-input>
          <img :src=" isShowConfirmPwd ? require('@/assets/images/disabledPwd.svg'):require('@/assets/images/showPwd.svg')"
               alt=""
               class="showPwdIcon"
               @click="isShowConfirmPwd=!isShowConfirmPwd"
               test_id= "setting_isShowConfirmPwd">
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   class="submit-button"
                   :loading="loading"
                   @click="submitForm('form')"
                   test_id ="setting_submit_resetPwd">{{$t('setting.setPassword.submit')}}</el-button>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   class="cancel-button"
                   :disabled="cancel"
                   @click="resetForm('form')">{{$t('setting.setPassword.cancel')}}</el-button>
      </div>
    </el-dialog>
    <success-confirm ref="successConfirm"
                     page_id="page_setting_success_confirm"></success-confirm>
  </div>

</template>
<script>
import successConfirm from './successConfirm'
import { Base64 } from 'js-base64'
export default {
  // 增加密码规则：必须为数字和字母组合，长度6-16
  data () {
    var checkOldPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('setting.setPassword.oldPassword')))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      let patrn = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,16}$/
      if (value === '') {
        callback(new Error(this.$t('setting.setPassword.newPassword')))
      } else if (!patrn.exec(value)) {
        callback(new Error(this.$t('setting.setPassword.checkPassword')))
      } else {
        if (this.form.newPassword !== '') {
          this.$refs.form.validateField('confirmPassword')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('setting.setPassword.confirmPassword')))
      } else if (value !== this.form.newPassword) {
        callback(new Error(this.$t('setting.setPassword.passwordInconsistent')))
      } else {
        callback()
      }
    }
    return {
      isShowOldPwd: false,
      isShowNewPwd: false,
      isShowConfirmPwd: false,
      dialogFormVisible: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      formLabelWidth: '120px',
      labelPosition: 'top',
      loading: false,
      cancel: false,
      rules: {
        oldPassword: [
          { validator: checkOldPassword, trigger: 'change' }
        ],
        newPassword: [
          { validator: validatePass, trigger: 'change' }
        ],
        confirmPassword: [
          { validator: validatePass2, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        this.loading = true
        this.cancel = true
        this.httpRequest(valid)
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.dialogFormVisible = false
    },
    async httpRequest (valid) {
      if (valid) {
        let params = {
          source: 'web',
          oldPassword: this.form.oldPassword,
          newPassword: Base64.encode(this.form.newPassword),
          confirmPassword: Base64.encode(this.form.confirmPassword),
          subject: this.$store.state.user.profile.sub,
          email: this.$store.state.user.profile.email,
          name: this.$store.state.user.profile.name
        }
        const result = await this.$api.changePassword(params)
        // .then(result => {
        //   console.log('datadata', result)
        //   if (Number(result.code) === 200) {
        //     console.log(200)
        //     this.dialogFormVisible = false
        //     this.loading = false
        //     this.cancel = false
        //     this.$refs['form'].resetFields()
        //     this.successConfirm()
        //     // this.$message.success('修改密码成功！')
        //     // this.$router.push('/login');
        //     // let path = this.$route.query.redirect || '/login'
        //   } else {
        //     this.loading = false
        //     this.cancel = false
        //     console.log('!200')
        //     let status = result.code
        //     this.$message.error(this.$t('setting.' + status))
        //   }
        // }).catch(error => {
        //   this.loading = false
        //   this.cancel = false
        //   console.log(error.msg == 'password is not match')
        //   if (error.code == 500 && error.msg == 'password is not match') {
        //     this.$message.error(this.$t('setting.setPassword.notMatch'))
        //   } else {
        //     this.$message.error(this.$t('setting.setPassword.fail'))
        //   }
        // })
        if (!result) return this.$message.error(this.$t('setting.setPassword.notMatch'))
        if (+result.code === 200) {
          this.dialogFormVisible = false
          this.loading = false
          this.cancel = false
          this.$refs['form'].resetFields()
          this.successConfirm()
        } else {
          this.loading = false
          this.cancel = false
          this.$message.error(this.$t(`setting.setPassword.${result.code}`))
        }
      } else {
        this.loading = false
        this.cancel = false
        console.log('error submit!!')
        return false
      }
    },
    successConfirm () {
      this.$refs.successConfirm.dialogFormVisible = true
    }
  },
  components: { successConfirm }
}
</script>
<style lang="scss">
.page-password {
  .showPwdIcon {
    position: absolute;
    top: 11px;
    right: 14px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .form-password {
    margin: 0rem 2.5rem;
    padding-bottom: 0rem;
  }
  h2 {
    line-height: 41px;
    font-size: 22px;
    text-align: center;
    font-family: PingFangTC-Regular;
    margin-top: -1rem;
    font-family: Muli-Bold;
    color: #24282d;
    letter-spacing: 0.27px;
  }
  .submit-button,
  .cancel-button {
    width: 100%;
    height: 100%;
    margin: auto;
    line-height: 20px;
    color: black !important;
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .cancel-button {
    background: white !important;
    border: 1px solid black !important;
  }
  .dialog-footer {
    width: 50%;
    height: 3rem;
    margin: 1rem auto;
  }
  .dialog-footer:first-child {
    margin-top: -1rem;
  }
  .el-form-item__label {
    font-family: Muli-Regular !important;
    font-size: 11px !important;
    color: #7d7d7d !important;
    letter-spacing: 0.13px !important;
  }
  .el-input__inner {
    border: 1px solid #e0e0e0 !important;
    border-radius: 5px !important;
    font-family: Muli-Bold !important;
    font-size: 14px !important;
    color: #24282d !important;
    letter-spacing: 0 !important;
  }
}
</style>
